import { Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { fetchAllCustomers } from 'api/customers';
import { updateCustomer } from 'api/customers';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getHttpErrorMessage } from 'utils/http';
import { App } from 'antd';

function AddCustomerToCompanyModal({ open, company, onClose, onSuccess }) {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      setSelectedCustomerId(null);
      setLoading(true);
      const ids = (company?.customers ?? []).map((c) => c.id);
      fetchAllCustomers({ page_size: 100 })
        .then((res) => {
          const data = getData(res);
          const results = data?.data?.results ?? data?.results ?? (Array.isArray(data) ? data : []);
          const all = Array.isArray(results) ? results : [];
          setCustomers(all.filter((c) => !ids.includes(c.id)));
        })
        .catch(captureException)
        .finally(() => setLoading(false));
    }
  }, [open, company?.id]);

  const handleOk = () => {
    if (!selectedCustomerId) {
      message.warning('Please select a customer');
      return;
    }
    setSaving(true);
    const selectedCustomer = customers.find((c) => c.id === selectedCustomerId);
    updateCustomer(selectedCustomerId, { company: company.id })
      .then(() => {
        onSuccess?.({
          id: selectedCustomer.id,
          name: selectedCustomer.name,
          email: selectedCustomer.email,
          phone: selectedCustomer.phone,
        });
        message.success('Customer added to company');
        onClose();
      })
      .catch((e) => {
        captureException(e);
        message.error(getHttpErrorMessage(e));
      })
      .finally(() => setSaving(false));
  };

  const options = customers.map((c) => ({
    value: c.id,
    label: `${c.name || 'No name'}${c.email ? ` (${c.email})` : ''}`,
  }));

  return (
    <Modal
      title="Add Customer to Company"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={saving}
      destroyOnClose
      okText="Add"
    >
      <Select
        style={{ width: '100%' }}
        placeholder="Search and select a customer"
        loading={loading}
        value={selectedCustomerId}
        onChange={setSelectedCustomerId}
        showSearch
        optionFilterProp="label"
        options={options}
      />
    </Modal>
  );
}

export default AddCustomerToCompanyModal;
